const projectData = [
  {
    id: 1,
    projectName: "Kobiela z Polańskim. 1959",
    demo: "https://pl.pinterest.com/pin/warsaw-1959-roman-polanski-with-bogumi-kobiela-at-the-club-of-architecture-students-photo-by-tadeusz-rolke--482025966339966570",
    imgsrc: "assets/1.png",
  },
  {
    id: 2,
    projectName:
      "Bogumił Kobiela i Zbigniew Cybulski ze swoją ówczesną żoną Elżbietą Chwalibóg. Sopot 1960",
    demo: "https://film.wp.pl/zbigniew-cybulski-nie-odnalazl-sie-w-roli-meza-i-ojca-ostatnia-noc-zycia-spedzil-z-kochanka-6336269454096513g/3",
    imgsrc: "assets/12.jpg",
  },
  {
    id: 3,
    projectName: "Jako Jan Piszczyk w filmie pt. 'Zezowate szczęście'. 1960",
    demo: "https://www.polskieradio.pl/39/156/Artykul/2486589,Zezowate-szczescie-62-lata-z-Janem-Piszczykiem",
    imgsrc: "assets/4.jfif",
  },
  {
    id: 4,
    projectName: "Kabaret 'Wagabunda'. 1963",
    demo: "https://pl.wikipedia.org/wiki/Kabaret_Wagabunda",
    imgsrc: "assets/18.jpg",
  },
  {
    id: 5,
    projectName: "W programie Jerzego Gruzy 'Poznajmy się'. 1964",
    demo: "https://pl.wikipedia.org/wiki/Poznajmy_si%C4%99",
    imgsrc: "assets/19.jpg",
  },
  {
    id: 6,
    projectName: "Rękopis znaleziony w Saragossie. 1965",
    demo: "https://film.wp.pl/bogumil-kobiela-czul-ze-moze-go-spotkac-cos-zlego-pisal-o-tym-w-liscie-do-zony-6025229970293889g/5",
    imgsrc: "assets/22.jpg",
  },
  {
    id: 7,
    projectName:
      "Maja Wodecka i Bogumił Kobiela w komedii 'Człowiek z M-3'. 1968",
    demo: "https://pl.wikipedia.org/wiki/Cz%C5%82owiek_z_M-3",
    imgsrc: "assets/3.webp",
  },
  {
    id: 8,
    projectName: "1931 - 1969",
    demo: "https://pl.wikipedia.org/wiki/Bogumi%C5%82_Kobiela",
    imgsrc: "assets/21.jpg",
  },
];

export default projectData;
